//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is the property of 6over6 Ltd. and its licensors. Any use of the Software is strictly prohibited unless an explicit license or permission is granted by 6over6 Ltd.
import Utils from "../../../../../common/services/Utils.js";

const deviceDetails = Utils.getDeviceDetails();
export default {
  namespaced: true,
  state: {
    socketId: null,
    sessionId: null,
    /** Set when client-side QR TTL elapsed; show "refresh page" on QR pages. Not cleared on socket reconnect. */
    qrRefreshNeeded: false,
    /** Timeout id for client-side QR expiry (cleared when the timer fires) */
    _qrExpiryTimeoutId: null,
    userId: null,
    osName: deviceDetails.osName,
    osVersion: deviceDetails.osVersion,
    browserName: deviceDetails.browserName,
    browserVersion: deviceDetails.browserVersion,
    clientId: null,
    serverUrl: null,
    options: null,
    campaign: null,
    appVersion: null,
  },
  getters: {
    socket_id: (state) => {
      return state.socketId;
    },
  },
};
